import React from 'react';
import ApplicationsSection from '../components/ApplicationsSection';
import BenefitsSection from '../components/BenefitsSection';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';
import '../styles/HomePage.css';

const ApplicationsPage = () => {
  const handleNavigation = (section) => {
    if (section === 'applications') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      document.getElementById(section)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="applications-page pt-20">
      <SEOHead 
        title="Aerogel Applications | EV Safety, Industrial & Aerospace | SolidCloud"
        description="Advanced aerogel applications for EV battery thermal management, industrial insulation, transportation, and aerospace. 5-10× better insulation than traditional materials."
        keywords="EV battery insulation, thermal runaway mitigation, industrial thermal insulation, aerospace insulation, mobility thermal barriers"
      />
      <ApplicationsSection />
      <BenefitsSection />
      <Footer onNavigate={handleNavigation} />
    </div>
  );
};

export default ApplicationsPage;
